import { render, staticRenderFns } from "./DeviceShareDeleteDialog.vue?vue&type=template&id=9ff45956&scoped=true"
import script from "./DeviceShareDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./DeviceShareDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeviceShareDeleteDialog.vue?vue&type=style&index=0&id=9ff45956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff45956",
  null
  
)

export default component.exports